import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/module/carousel.css";

// import bg4 from "../../assets/images/img/bg-4.webp";

const slides = [
  {
    title: "Discovery and Assessment",
    desc: "We start by reviewing your existing website to understand your goals, target audience, and what custom changes are needed to improve performance and usability.",
  },
  {
    title: "Planning and Requirements",
    desc: "We outline a clear plan that defines the customization scope, required features, timeline, and any integrations or design changes needed.",
  },
  {
    title: "Design Enhancement",
    desc: "We improve the visual layout and user interface by updating page elements, adding new components, and aligning the design with your brand identity.",
  },
  {
    title: "Custom Development",
    desc: "Our developers implement the planned features and changes—whether it’s modifying code, integrating tools, or adding new sections—to suit your exact needs.",
  },
  {
    title: "Testing and Review",
    desc: "We thoroughly test all customized elements to ensure everything works properly across devices, browsers, and screen sizes.",
  },
  {
    title: "Launch and Go-Live",
    desc: "After final checks, we push the custom updates live on your site, making the improved experience accessible to your users.",
  },
  {
    title: "Post-Launch Support",
    desc: "We provide continuous support to fix any issues, fine-tune performance, and make further enhancements as your website evolves.",
  },
];

export default function WebCustSlider() {
  useScrollReveal("slide-from-left");
  useScrollReveal("drop-from-top");
  useScrollReveal("slide-from-bottom");
  const settings = {
    dots: true, // Show dots
    infinite: false, // Do not loop infinitely
    speed: 500, // Slide animation speed
    slidesToShow: 3, // Show 3 slides at once
    slidesToScroll: 1, // Scroll one slide at a time
    swipeToSlide: true, // Allow drag/swipe
    arrows: false, // Show arrows
    responsive: [
      // Responsive settings for smaller screens
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div id="karuzela" className="section section__carousel">
      {/* <img
        className="container-bg image-background left slide-from-left"
        src={bg4}
        alt="container background"
        style={{ marginTop: "400px" }}
      /> */}
      <div className="container carousel">
        <h5 className="drop-from-top">step by step</h5>
        <div className="title flex drop-from-top">
          <h2 style={{ marginBottom: 30 }}>
            What does the Website Customization process look like?
          </h2>
        </div>

        <div className="carousel-slider slick-initialized slick-slider slick-dotted slide-from-bottom">
          <div className="slick-list draggable">
            <Slider {...settings}>
              {slides.map((slide, index) => (
                <div key={index} className="card" style={{ padding: 10 }}>
                  <div className="card-element">
                    <h6 className="title">{slide.title}</h6>
                    <span className="desc mini">{slide.desc}</span>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
}
